import { Heading, Grid, useTheme, Text } from '@simplywallst/ui-core';
import { Narrative } from '../../hooks/useNarrative';
import { getDisclaimer } from './utils';

export interface Props {
  narrativeType: Narrative['type'] | null | undefined;
  userHoldsPosition: boolean | null | undefined;
  authorDisplayName: string | null | undefined;
  companyTicker: string | null | undefined;
  authorIsExternal: boolean | null | undefined;
}

export const DisclaimerContentBlock = ({
  userHoldsPosition,
  companyTicker,
  authorDisplayName,
  narrativeType,
  authorIsExternal,
}: Props) => {
  const theme = useTheme();
  const content = getDisclaimer({
    userHoldsPosition,
    companyTicker,
    authorDisplayName,
    narrativeType,
    authorIsExternal,
  });
  if (!content) return null;
  return (
    <Grid
      as="section"
      gap={`${theme.x2space}px`}
      backgroundColor="noir"
      borderRadius="x0"
      borderRadiusLg="x1"
      paddingX="x3"
      paddingY="x2"
      data-cy-id="narrative-disclaimer"
    >
      <Heading lineClamp={2} typography="small" as="h2" color="textSofter">
        Disclaimer
      </Heading>
      <Grid gap={`${theme.x3spacePx}px`} gapMd={`${theme.x2spacePx}px`}>
        <Text as="em" typography="xSmall" color="textSoft">
          {content}
        </Text>
      </Grid>
    </Grid>
  );
};
